function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgAno = function SvgAno(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M23.765 5.167v-1h3.389c1.188 0 2.15.97 2.15 2.166V26.6a1.9 1.9 0 01-1.9 1.9H4.868a2.159 2.159 0 01-2.15-2.167v-20c0-1.195.961-2.166 2.15-2.166h3.389v1h-3.39c-.634 0-1.15.521-1.15 1.166v20c0 .646.516 1.167 1.15 1.167h22.537a.9.9 0 00.9-.9V6.333c0-.645-.516-1.166-1.15-1.166h-3.39zM9.908 6.75a.5.5 0 01-1 0V3a.5.5 0 111 0v3.75zm13.206 0a.5.5 0 01-1 0V3a.5.5 0 111 0v3.75zm-6.603 0a.5.5 0 01-1 0V3a.5.5 0 111 0v3.75zm.65-1.583v-1h4.302v1h-4.301zm-6.603 0v-1h4.302v1h-4.302zM7.2 10.5h3.6a.7.7 0 01.7.7v3.6a.7.7 0 01-.7.7H7.2a.7.7 0 01-.7-.7v-3.6a.7.7 0 01.7-.7zm.3 4h3v-3h-3v3zm-.3 4h3.6a.7.7 0 01.7.7v3.6a.7.7 0 01-.7.7H7.2a.7.7 0 01-.7-.7v-3.6a.7.7 0 01.7-.7zm.3 4h3v-3h-3v3zm6.7-4h3.6a.7.7 0 01.7.7v3.6a.7.7 0 01-.7.7h-3.6a.7.7 0 01-.7-.7v-3.6a.7.7 0 01.7-.7zm.3 4h3v-3h-3v3zm-.3-12h3.6a.7.7 0 01.7.7v3.6a.7.7 0 01-.7.7h-3.6a.7.7 0 01-.7-.7v-3.6a.7.7 0 01.7-.7zm.3 4h3v-3h-3v3zm6.7-4h3.6a.7.7 0 01.7.7v3.6a.7.7 0 01-.7.7h-3.6a.7.7 0 01-.7-.7v-3.6a.7.7 0 01.7-.7zm.3 4h3v-3h-3v3z"
  }));
};
SvgAno.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgAno.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgAno;